import React from 'react'
import PropTypes from 'prop-types'
import { Loader } from 'shared/UI/Loader'

import './style.css.scss'

const TransitionOverlay = ({ isReady }) => {
  return (
    <div className={`transition-overlay ${!isReady ? 'active' : ''}`}>
      <Loader />
    </div>
  )
}

TransitionOverlay.propTypes = {
  isReady: PropTypes.bool.isRequired
}

export default TransitionOverlay
